import { z } from 'zod';

import { validateFileSize } from './helpers';

const validationSchema = z.object({
  csv: z.any().refine(file => validateFileSize(file), 'Max file size is 10MB.'),
  roofTopId: z.string().min(1, 'Please select a dealership').uuid(),
});

export default validationSchema;
